/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum CountryCodeCurrency {
  ES = 'EUR',
  MX = 'MXN',
  IT = 'EUR',
  PL = 'PLN',
  BR = 'BRL',
}
